import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { WeaDatePicker } from 'ecCom';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';

@observer
export default class DatePicker extends React.Component<ExcelTableCellProps, any> {
    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const fieldName = getDomIdByFieldKey(bindObj.path);
        const bind = bindObj.bind();
        const {quickEditStore ,getDetailFormValues} = card;
        const { viewAttr: _viewAttr, isEdit, isMandatory } = bind;
        const { format } = cell;
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }
        if (format) {//日期字段单元格格式 直接通过字段参数实现
            let numberType = format.numberType;
            if (numberType == "3") {
            }
        }
        let canQuickedit = bindObj.isquickedit && viewAttr == '1';
        //新增 显示模板的快编模式下 编辑模板中是否允许修改已有明细的判断
        if (canQuickedit && excel.detailProps && !excel.detailProps["isEdit"]) {
            canQuickedit = false;
        }
		let isDisplay = '';
        if(!canQuickedit){
            isDisplay = 'none';
        }
        return (
            <div className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} {...cell.cellProps}
            onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaDatePicker ecId={`${this && this.props && this.props.ecId || ''}_WeaDatePicker@4j86gr`}
                    {...bind}
                    {...bind.value}
                    fieldName={fieldName}
                    noInput={true}
                    viewAttr={viewAttr}
                    format="yyyy-MM-dd HH:mm"
                    showTime
                />
                <span className="editicon" style={{display:isDisplay}}><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/browser-element/DateTimePicker.tsx